$(document).ready(function() {
    $("form").each(function() {
        $(this).validate({
            rules: {
                email: {
                    required: true,
                    maxlength: 255,
                    email: true,
                },
            },
            errorPlacement: function(error, element) {
                error.insertAfter(element);
            },
            errorElement: 'p',
            errorClass: 'formError',
        });
    });
});